let viewerString = "tz1WwLpnjMbjfQEmUpExC8wqNuZP5vTjYqgS";
const viewer = new URLSearchParams(window.location.search).get('viewer');
if (viewer) {
viewerString = viewer;
}

import './style.css'
import * as THREE from 'three'
var seedrandom = require('seedrandom');
var rng = seedrandom(viewerString);

import gsap from 'gsap'
import * as lilgui from 'lil-gui'
import SkyShader from './SkyShader';


const SimplexNoise = require('simplex-noise');


const loadingManager = new THREE.LoadingManager();

const textureLoader = new THREE.TextureLoader(loadingManager);
const maxDepth = -20;
const overMaxDepth = -50;

const fogEnabled = true;
let orthographic = true;



let d = new Date();
let todayMonth,todayDay;

let realDayTimeConfig = {
    offset: 0,
    nearNearFog: 0,
    nearFog: 35,
    farFog: 50
}

let moonConfig = {
    size: 2,
    rotationX:2.57610597594363,
    rotationY:4.66212349792725,
    rotationZ:2.73318560862312,
}


let sunConfig = {
    size: 4
}


moonConfig.size = 2+rng()*4;
sunConfig.size = moonConfig.size+rng()*3;

const normalizedRealDayTime = () => {
  var h = d.getHours() * 60 * 60;
  var m = d.getMinutes() * 60;
  var s = d.getSeconds();

  todayMonth = d.getMonth() + 1;
  todayDay = d.getDate();

  var hh = (h)%(60*60*24);
  var t = hh + m + s;
  var norm =  t / (60 * 60 * 24);
  norm += realDayTimeConfig.offset-0.25;
  if(norm > 1) norm -= 1;
  return norm;
}


const updateSizes = () => {
    let res = {
        orthoSize: 25,
        width: window.innerWidth,
        height: window.innerHeight,
        size: Math.min(window.innerHeight, window.innerWidth),
        ratio: window.innerWidth / window.innerHeight,
        pixelRatio: window.devicePixelRatio,
        sizeCorrection: 1 / 800 * Math.min(window.innerHeight, window.innerWidth),
        widthCorrection: 1 / 800 * window.innerWidth,
        heightCorrection: 1 / 800 * window.innerHeight
    };
    return res;
};

let sizes = updateSizes();

let debugVars = {
    noiseSpeed: 0.00005
}

let mX = sizes.width / 2;
let mY = sizes.height;

window.addEventListener('mousemove', (e) => {
    mX = e.clientX;
    mY = e.clientY;
});

const simplex = new SimplexNoise(rng());

const gui = new lilgui.GUI();
gui.hide();
let time = Date.now();
const scene = new THREE.Scene();
scene.background = new THREE.Color(0x303030);




let camera;

if(orthographic)
{
    let w = sizes.width * 0.05;
    let h = sizes.height * 0.1;
    camera = new THREE.OrthographicCamera(-w, w, h, 0, 0, 900);
} else {
    camera = new THREE.PerspectiveCamera(70, 0, 2000);
}

let perspectiveCameraConfig = {
    z: 200,
    y: 0
};
//let camera = new THREE.PerspectiveCamera(65,sizes.ratio,0,400);

const canvas = document.querySelector('.webgl');
const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });

let delta = 0;


const getRandomBgColors = (baseColor) => {
    var target = new THREE.Color();
    baseColor.getHSL(target);
    target = target.offsetHSL(0.5,0,-0.8);
    var r = target.h;
    var maxDiffer = 0.3;
    let low = new THREE.Color(0x000000);
    let baseCol = new THREE.Color(0x000000);
    let high = new THREE.Color(0x000000);

    low.setHSL(r, 0.5, 0.72);//new THREE.Color("hsl("+r.toString()+", 53%, 72%)");
    baseCol.setHSL(r, 0.5, 0.72);//new THREE.Color("hsl("+r.toString()+", 53%, 72%)");
    high.setHSL(r, 0.65, 0.72);//new THREE.Color("hsl("+r.toString()+", 53%, 72%)");

    var rLow = (rng() - 0.5) * 2;
    var rHigh = (rng() - 0.5) * 2;
    low.offsetHSL(rLow * maxDiffer, rLow * maxDiffer, rLow * maxDiffer);
    var tempL = new THREE.Color(0x000000);
    low.getHSL(tempL);
    low.setHSL(tempL.h, tempL.s, tempL.l * 0.2);
    high.offsetHSL(rHigh * maxDiffer, rHigh * maxDiffer, rHigh * maxDiffer);

    return [low, high];
}

const getRandomMountainColors = () => {
    var r = rng();
    var maxDiffer = 0.7;
    let low = new THREE.Color(0x000000);
    let baseCol = new THREE.Color(0x000000);
    let high = new THREE.Color(0x000000);

    low.setHSL(r, 0.5, 0.72);//new THREE.Color("hsl("+r.toString()+", 53%, 72%)");
    baseCol.setHSL(r, 0.5, 0.72);//new THREE.Color("hsl("+r.toString()+", 53%, 72%)");
    high.setHSL(r, 0.5, 0.72);//new THREE.Color("hsl("+r.toString()+", 53%, 72%)");

    var rLow = (rng() - 0.5) * 2;
    var rHigh = (rng() - 0.5) * 2;
    low.offsetHSL(rLow * maxDiffer, rLow * maxDiffer, rLow * maxDiffer);
    high.offsetHSL(rHigh * maxDiffer, rHigh * maxDiffer, rHigh * maxDiffer);

    return [high,
        baseCol,
        low
    ];
}
let mountainColor = getRandomMountainColors();
let bgColors = getRandomBgColors(mountainColor[1]);// getRandomBgColors(mountainColor[1]);
let mountainConfig = {
    maxDepth: -20,
    width: 200,
    step: 0.5,
    wireframe: false,
    layers: 50,
    bgColors: bgColors/* [
        0x100729,
        0x623f5f
    ] */,
    colors: mountainColor/* [
        0x372B39,
        0x864D5C,
        0xBB6159

        0x111111,
        0x888888,
        0xeeeeee
    ] */
}

mountainConfig.maxDepth = (20+rng()*20)*-1;


let skyDomeRadius = 300.01;
//*Sky Dome*//
let sphereMaterial = new THREE.ShaderMaterial({
    uniforms: {
        skyRadius: { value: skyDomeRadius },
        env_c1: { value: mountainConfig.bgColors[0] },
        env_c2: { value: mountainConfig.bgColors[1] },
        noiseOffset: { value: new THREE.Vector3(rng(), rng()*30, rng()*100.1) },
        starSize: { value: 0.001 },
        starDensity: { value: 0.4 },
        clusterStrength: { value: 0.02 },
        starAlpha: { value: 0.02 },
        clusterSize: { value: 0.1 },
        time: { value: 0 },
    },
    vertexShader: SkyShader.vertexShader,
    fragmentShader: SkyShader.fragmentShader,
    side: THREE.DoubleSide,
});

let sphereGeometry = new THREE.SphereGeometry(skyDomeRadius, 6, 6);
let skyDome = new THREE.Mesh(sphereGeometry, sphereMaterial);
skyDome.rotation.x = Math.PI/2;
skyDome.position.y = skyDomeRadius;
skyDome.position.z = -skyDomeRadius;

scene.add(skyDome);

const groundUpwards = new THREE.Mesh(
    new THREE.PlaneBufferGeometry(200, 200, 1, 1),
    new THREE.MeshBasicMaterial({ color: 0xffffff })
);

groundUpwards.position.z = 0;
groundUpwards.rotation.set(-90 / 180 * Math.PI, 0, 0);
//scene.add(groundUpwards);

const groundDownwards = new THREE.Mesh(
    new THREE.PlaneBufferGeometry(200, 200, 1, 1),
    new THREE.MeshBasicMaterial({ color: 0xffffff })
);

groundDownwards.position.z = 0;
groundDownwards.rotation.set(90 / 180 * Math.PI, 0, 0);
scene.add(groundDownwards);

const fogColor = () => {
    var a = mountainConfig.bgColors[0];//new THREE.Color(mountainConfig.bgColors[0]);
    var b = mountainConfig.bgColors[1];//new THREE.Color(mountainConfig.bgColors[1]);

    var temp = new THREE.Color(a);

    var shifted = normalizedRealDayTime() + 0.25;
    if (shifted > 1) shifted -= 1;

    if (shifted < 0.5) return temp.lerpColors(a, b, shifted * 2);
    if (shifted >= 0.5) return temp.lerpColors(a, b, 1 - (shifted - 0.5) * 2);

    return temp.lerpColors(a, b, shifted);
}


scene.background = fogColor();
if (fogEnabled) scene.fog = new THREE.Fog(fogColor(), 5, 50);

const getMountainColor = (normalized, stretch = 1) => {
    var total = mountainConfig.colors.length;
    var raw = THREE.MathUtils.mapLinear(normalized, 0, 1, 0, total);

    var before = Math.floor(raw);
    var after = Math.ceil(raw);

    var partial = (raw - before) / total * stretch

    var a = new THREE.Color(mountainConfig.colors[before]);
    var b = new THREE.Color(mountainConfig.colors[after]);

    return a.lerpColors(a, b, partial);
}


let bgPlaneMaterial = new THREE.MeshStandardMaterial({ color: 0x623f5f });
//const bgPlane = new THREE.Mesh(new THREE.PlaneBufferGeometry(mountainConfig.width * 1.5, mountainConfig.width * 1.5, 1, 1), sphereMaterial);
const bgPlane = new THREE.Mesh(new THREE.PlaneBufferGeometry(mountainConfig.width*1.5,mountainConfig.width*1.5,1,1),new THREE.MeshBasicMaterial({color: 0x623f5f}));
scene.add(bgPlane);

bgPlane.position.z = mountainConfig.maxDepth*2.1 - 50;



const sunMaterial = new THREE.MeshBasicMaterial({fog: false, color: 0xffffff });
const moonMaterial = new THREE.MeshBasicMaterial({ 
    /* map:moonAlbedo,  */
    /* emissive: 0xffffff, */
    /* emissiveIntensity:20, */
    color: 0xf7f3ba,
    /* displacementMap: moonDsp, */
    fog: false
});

let sphereBufferSun = new THREE.SphereBufferGeometry(sunConfig.size, 32, 32);
let sphereBufferMoon = new THREE.SphereBufferGeometry(moonConfig.size, 32, 32);

let sun = new THREE.Mesh(sphereBufferSun, sunMaterial);
let moon = new THREE.Mesh(sphereBufferMoon, moonMaterial);

const sunPos = (normalized) => {
    var radianAngel = Math.PI * 2 * normalized;
    var rW = sizes.orthoSize * 1.5;
    var rH = sizes.orthoSize * 1.4;
    var x = Math.cos(radianAngel) * rW * -1
    var y = Math.sin(radianAngel) * rH;
    return new THREE.Vector2(x, y);
}

const helperSunPos = (normalized) => {
    var radianAngel = Math.PI * 2 * normalized;
    var rW = sizes.orthoSize * 2.5;
    var rH = sizes.orthoSize * 3;
    var x = Math.cos(radianAngel) * rW * -1.5
    var y = Math.sin(radianAngel) * rH * 1.5;
    return new THREE.Vector2(x, y);
}

const moonPos = (normalized) => {
    var radianAngel = Math.PI + Math.PI * 2 * normalized;
    var rW = sizes.orthoSize * 1.3;
    var rH = sizes.orthoSize * 1.0;
    var x = Math.cos(radianAngel) * rW * -1.5
    var y = Math.sin(radianAngel) * rH * 1.5;
    return new THREE.Vector2(x, y);
}

const updateSunAndMoon = () => {
    var sPos = sunPos(normalizedRealDayTime());
    var helperSPos = sPos;//helperSunPos(normalizedRealDayTime());    
    var mPos = moonPos(normalizedRealDayTime());

    sun.position.set(sPos.x, sPos.y, mountainConfig.maxDepth*2.1);
    lightSun.position.set(sPos.x, sPos.y, mountainConfig.maxDepth*2.1);
    helperSun.position.set(helperSPos.x, helperSPos.y, 30);
    lightMoon.position.set(mPos.x, mPos.y, mountainConfig.maxDepth*2.1);

    moon.position.set(mPos.x, mPos.y, mountainConfig.maxDepth*2.1-moonConfig.size*2);
}

const lightSun = new THREE.PointLight(0xD9BAB5, 0.5, mountainConfig.maxDepth*2.1);
const helperSun = new THREE.PointLight(0xD9BAB5, 0.7, mountainConfig.maxDepth*2.1);
const ambientLight = new THREE.AmbientLight(mountainConfig.colors[0], 0.1);
const lightMoon = new THREE.PointLight(0xDDD1A3, 0.6, mountainConfig.maxDepth*2.1);

updateSunAndMoon();

scene.add(lightSun);
scene.add(helperSun);
scene.add(lightMoon);

//scene.add(ambientLight);
scene.add(sun);
scene.add(moon);

const updateDepth = () => {
    for (var i = 0; i < mountainConfig.layers; i++) {
        mountains[i].position.z = mountainConfig.maxDepth * (i + 1) / mountainConfig.layers - sizes.orthoSize / 2;
    }
    bgPlane.position.z = mountainConfig.maxDepth*2.2 - 50;
}

const updateFog = () => 
{
    var intensity = 0;
    var shifted = 0;
    var shifted = normalizedRealDayTime() + 0.25;
    if (shifted > 1) shifted -= 1;
    if (shifted < 0.5) intensity = THREE.MathUtils.mapLinear(shifted * 2, 0, 1, 0, 1)
    if (shifted >= 0.5) intensity = THREE.MathUtils.mapLinear(1 - (shifted - 0.5) * 2, 0, 1, 0, 1)
    scene.fog.far = realDayTimeConfig.nearFog + (intensity) * realDayTimeConfig.farFog
    scene.fog.near = realDayTimeConfig.nearNearFog;
}

gui.add(realDayTimeConfig, 'offset', 0, 1).onChange(() => {
    //console.log(normalizedRealDayTime());
});

gui.add(mountainConfig, 'maxDepth', -200, -2).onChange(() => {
    updateDepth();
});

gui.add(sunConfig, 'size', 0.1, 20).name("Sun Size").onChange(() => {
    sphereBufferSun = new THREE.SphereBufferGeometry(sunConfig.size,32,32);
    sun.geometry = sphereBufferSun;
    updateSunAndMoon();
});

gui.add(moonConfig, 'size', 0.1, 20).name("Moon Size").onChange(() => {
    sphereBufferMoon = new THREE.SphereBufferGeometry(moonConfig.size,32,32);
    moon.geometry = sphereBufferMoon;
    updateSunAndMoon();
});

gui.add(realDayTimeConfig, 'nearNearFog', 0, 300).name("Near Near Fog").onChange(() => {
    updateFog();
});


gui.add(realDayTimeConfig, 'nearFog', 0, 300).name("Near Fog").onChange(() => {
    updateFog();
});

gui.add(realDayTimeConfig, 'farFog', 0, 300).name("Far Fog").onChange(() => {
    updateFog();
});

/* 

gui.add(moonConfig, 'rotationX',0,Math.PI*2).name("Moon Rotation X").onChange(() => {
    moon.rotation.x = moonConfig.rotationX;
});
gui.add(moonConfig, 'rotationY',0,Math.PI*2).name("Moon Rotation Y").onChange(() => {
    moon.rotation.y = moonConfig.rotationY;
});
gui.add(moonConfig, 'rotationZ',0,Math.PI*2).name("Moon Rotation Z").onChange(() => {
    moon.rotation.z = moonConfig.rotationZ;
}); */



const getLayeredNoise = (x, y, config) => {
    var res = 1;
    let tt = debugVars.noiseSpeed;
    for (var i = 0; i < config.layers; i++) {
        var scale = config.scales[i];
        res += simplex.noise2D(config.offset + (tt + x) * scale, config.offset + (tt + y) * scale);
    }

    return res / config.layers;
}

const setupMountain = (layer) => {


    var depth = (layer + 0.1) / mountainConfig.layers;
    var iDepth = 1 - depth;

    let nC = {
        layers: 3,
        offset: simplex.noise2D(layer, depth) * 1000,
        scales: [
            0.01 * iDepth,
            0.04 * iDepth,
            0.07 * iDepth,
            0.032 * iDepth
        ]
    }


    var bottomY = -20;
    var offsetY = 15 * depth;

    var count = Math.round(mountainConfig.width / mountainConfig.step * 2);

    var positionsArray = new Float32Array(3 * 3 * count);
    var z = 0;

    var left = -mountainConfig.width / 2;


    //Get upper-edge-points
    var upperEdge = new Float32Array(count);
    var p = new THREE.Vector2(0, 0);
    upperEdge[0] = p.y;

    let lowerAngle = -10;
    let upperAngle = 5;

    for (var i = 1; i < count; i++) {
        var n = getLayeredNoise(p.x, p.y, nC);
        var alpha = THREE.MathUtils.mapLinear(n, -1, 1, lowerAngle, upperAngle) / 180 * Math.PI;
        var dirX = Math.cos(alpha) * 4;
        var dirY = Math.sin(alpha) * 4;
        if (p.y > 10 && dirY > 0) {

            p.x += 100;
        }

        p = p.add(new THREE.Vector2(dirX, dirY));

        upperEdge[i] = p.y;
    }

    for (var i = 0; i < count - 1; i++) {

        //  .
        //  |\
        //  '''
        //Upper
        positionsArray[18 * i] = left + mountainConfig.step * i;
        positionsArray[18 * i + 1] = offsetY + upperEdge[i];
        positionsArray[18 * i + 2] = z;


        //Lower-Left
        positionsArray[18 * i + 3] = left + mountainConfig.step * i;
        positionsArray[18 * i + 4] = bottomY;
        positionsArray[18 * i + 5] = z;


        //Lower-Right
        positionsArray[18 * i + 6] = left + mountainConfig.step * (i + 1);
        positionsArray[18 * i + 7] = bottomY;
        positionsArray[18 * i + 8] = z;

        //  ._.
        //   \|
        //    '
        //Upper Left
        positionsArray[18 * i + 9] = left + mountainConfig.step * i;
        positionsArray[18 * i + 10] = offsetY + upperEdge[i];
        positionsArray[18 * i + 11] = z;

        //Ascend here

        //Lower
        positionsArray[18 * i + 12] = left + mountainConfig.step * (i + 1);
        positionsArray[18 * i + 13] = bottomY;
        positionsArray[18 * i + 14] = z;

        //Upper Right
        positionsArray[18 * i + 15] = left + mountainConfig.step * (i + 1);
        positionsArray[18 * i + 16] = offsetY + upperEdge[i + 1]
        positionsArray[18 * i + 17] = z;

    }



    const positionsAttribute = new THREE.BufferAttribute(positionsArray, 3)
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', positionsAttribute);


    return geometry;
}

const assignUVs = (geometry) => {

    geometry.faceVertexUvs[0] = [];

    geometry.faces.forEach(function (face) {

        var components = ['x', 'y', 'z'].sort(function (a, b) {
            return Math.abs(face.normal[a]) > Math.abs(face.normal[b]);
        });

        var v1 = geometry.vertices[face.a];
        var v2 = geometry.vertices[face.b];
        var v3 = geometry.vertices[face.c];

        geometry.faceVertexUvs[0].push([
            new THREE.Vector2(v1[components[0]], v1[components[1]]),
            new THREE.Vector2(v2[components[0]], v2[components[1]]),
            new THREE.Vector2(v3[components[0]], v3[components[1]])
        ]);

    });

    geometry.uvsNeedUpdate = true;
}

window.addEventListener('resize', () => {
    sizes = updateSizes();
    updateCanvasSize();
    updateCamera();
});


let mouseControl = false;

window.addEventListener('click', () => {

    fastForward(0.25);
});

window.addEventListener('touchstart', () => {

    fastForward(0.25);
});

const fastForward = (amount) => {
    let newOff = realDayTimeConfig.offset+amount;
    if(newOff > 1)
    {
        
        let p2 = newOff-1;
        gsap.to(realDayTimeConfig, { duration: 0.5, offset: 1 });
        realDayTimeConfig.offset = 0;
        gsap.to(realDayTimeConfig, { duration: 0.5, delay:0.5, offset: p2 });
    } else {
        gsap.to(realDayTimeConfig, { duration: 1, offset: newOff });
    }
}

const toggleFullscreen = () => {
    let fullScreen = document.fullscreenElement ||  document.webkitFullscreenElement;
    if(!fullScreen)
    {
        if(canvas.requestFullscreen)
        {
            canvas.requestFullscreen();
        } else if(canvas.webkitRequestFullscreen)
        {
            canvas.webkitRequestFullscreen();
        }
        } else {
            if(document.exitFullscreen)
            {
                document.exitFullscreen();
            } else if(document.webkitExitFullscreen)
            {
                document.webkitExitFullscreen();
            }
        } 
}

const updateCanvasSize = () => {
    

    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(sizes.pixelRatio, 2))
}

const updateCamera = () => {

    
    if(camera.isOrthographicCamera == false)
    {
        camera.aspect = sizes.ratio;
        camera.updateProjectionMatrix();
        camera.position.z = perspectiveCameraConfig.z;
        camera.position.y = perspectiveCameraConfig.y;
    } else {
        let w = sizes.width * 0.05;
        let h = sizes.height * 0.1;
        
        camera.left = -w;
        camera.right = w;
        camera.top = h;
        camera.bottom = 0;
        camera.position.z = 0;
        camera.updateProjectionMatrix();
    }
}



//DEBUG

scene.add(camera);

let mountainGeometries = [];
let mountains = [];

for (var i = 0; i < mountainConfig.layers; i++) {
    let l = (Math.round(i / mountainConfig.layers * 60)).toString();
    let col = new THREE.Color("hsl(324, 48%, " + l + "%)");
    col = getMountainColor(i / mountainConfig.layers, 1.8);
    mountainGeometries[i] = setupMountain(i);
    mountains[i] = new THREE.Mesh(mountainGeometries[i], new THREE.MeshStandardMaterial({ flatShading: true, color: col, wireframe: mountainConfig.wireframe }))
    mountains[i].position.z = mountainConfig.maxDepth * (i + 1) / mountainConfig.layers - sizes.orthoSize / 2;
}


for (var i = 0; i < mountainConfig.layers; i++) {
    scene.add(mountains[i])
}

updateCanvasSize();



const tick = () => {
    d = new Date();
    const currentTime = Date.now();
    delta = currentTime - time;
    delta *= 0.01;
    time = currentTime;
    
    updateSunAndMoon();
    
    if (mouseControl) {
        camera.rotation.y = THREE.MathUtils.mapLinear(mX, 0, sizes.width, 0.2, -0.2);
        camera.rotation.x = THREE.MathUtils.mapLinear(mY, sizes.height / 2, sizes.height, 0, 0.4);
    }

    var c = fogColor();


    
    /* bgPlane.material.uniforms.env_c1.value = c;
    bgPlane.material.uniforms.env_c2.value = c; */
    
    //bgPlane.material.uniforms.time.value = time;
    if (fogEnabled) scene.fog.color = c;


    var shifted = 0;
    var shifted = normalizedRealDayTime() + 0.25;
    if (shifted > 1) shifted -= 1;
    var intensity = 0;
    if (shifted < 0.5) intensity = THREE.MathUtils.mapLinear(shifted * 2, 0, 1, 0, 1)
    if (shifted >= 0.5) intensity = THREE.MathUtils.mapLinear(1 - (shifted - 0.5) * 2, 0, 1, 0, 1)

    if (fogEnabled) {
        scene.fog.near = 0;
        scene.fog.far = realDayTimeConfig.nearFog + (intensity) * realDayTimeConfig.farFog
    }

    lightSun.intensity = intensity;
    helperSun.intensity = intensity;
    lightMoon.intensity = (1 - intensity);

    //bgPlane.material.uniforms.starAlpha.value = (1-intensity);

    ambientLight.intensity = intensity*0.6;
    /* 
    skyDome.rotation.y -= delta*0.001;
    skyDome.rotation.x += delta*0.001;
    */
    renderer.render(scene, camera);
    requestAnimationFrame(tick);
}
tick();
